import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BlockText from './BlockText';
import { tabletThresholdPixels } from '../../home/v4/styledComponents';

const Container = styled.div`
  @media (max-width: ${tabletThresholdPixels}) {
    width: unset;
    margin: 0px 22px;
  }
`;

function RowParagraph({ paragraph }) {
  return (
    <Container>
      <BlockText {...paragraph} />
    </Container>
  );
}

RowParagraph.propTypes = {
  paragraph: PropTypes.shape({}).isRequired,
};

export default RowParagraph;
